
<multi-input :compress="compress">
    <column :size="currentSelector.pSize || ''" v-for="currentSelector in selectors" :key="`selector-${currentSelector.modelField}`">
        <div class="sr-only">
          <label :for="currentSelector.modelField">{{currentSelector.label}}</label>
        </div>
        <a-select
                v-model="document[currentSelector.modelField]"
                :options="currentSelector.options"
                class="full-sz"
                :id="currentSelector.modelField"
                :name="currentSelector.modelField"></a-select>
    </column>
</multi-input>
